/*global customScriptPaths,legacyScripts,loadLegacyScriptAfterBundle*/

import svg4everybody from 'svg4everybody';
import fallback from './helpers/fallback';

// JE Specific Modules
import GlobalHelpers from './helpers/GlobalHelpers';
import moduleInitialiser from './modules';
import './pages';
import { parseJSON } from './helpers/fetchHelper';
import './logger';

var base = {

    // controls all of our base initialsation functions
    init: function () {

        base._runHelpers();
        moduleInitialiser();

        base._getLegacyScriptURL(); // load our legacy scripts (these will be ported over and this function should one day disappear)

        // SVG Sprite shim for IE
        svg4everybody();

    },

    _runHelpers: function () {

        GlobalHelpers.placeholderDetection();

    },

    // *******************************************
    // ***** Whole host of legacy JS loading *****
    // *******************************************
    //
    // Pings the server to get the rev-ed version of the jescript file to load (for legacy script)
    _getLegacyScriptURL: function () {

        const scriptsToLoad = (typeof legacyScripts !== 'undefined') ? legacyScripts : ['/assets/dist/js/jescript.min.js'];

        // then load in old legacy JS
        fetch('/asset/javascriptasset?assetUrl=jescript.js',
            {
                credentials: 'same-origin'
            })
            .then(parseJSON)
            .then((asset) => {
                scriptsToLoad.unshift(asset.url);
                base._loadLegacyScript(scriptsToLoad);
            }, () => {
                base._loadLegacyScript(scriptsToLoad);
            });
    },

    _loadLegacyScript: function (scripts) {

        if (Array.isArray(scripts)) {
            fallback.load({
                legacyScript: scripts
            }, {
                callback: function (success, failure) {
                    base._loaderCB(success, failure); // output loading logs

                    base._loadLegacyLinkedScripts();
                }
            });
        }

    },

    // loads any other associated scripts for this specific page
    // So usually 2 types (of legacy script)
    // 1. In page JS (ARGH)
    // 2. An externally linked function, such as an experiment script
    _loadLegacyLinkedScripts: function () {

        // function call for in-page legacy JS
        if (typeof loadLegacyScriptAfterBundle === 'function') {
            loadLegacyScriptAfterBundle();
        }

        // load in other custom scripts defined specific to current page, such as experiment JS etc.
        base._loadExternalLegacyScripts();

    },

    // to deal with legacy scripts defined specific to a page view
    // will take the `customScriptPaths` variable (if defined on the page) and load the scripts in that array
    _loadExternalLegacyScripts: function () {

        if (typeof customScriptPaths !== 'undefined') {
            GlobalHelpers.loadScripts(customScriptPaths);
        } else {
            console.log('No legacy external scripts found to load');
        }

    },

    // callback to report loader success/failures
    _loaderCB: function (success, failed) {
        // some logs to show the polyfills loaded
        if (success) {
            console.log('--- SUCCESSFULLY LOADED ---');
            console.log(success);
        }
        if (failed) {
            console.log('--- FAILED LOADING ---');
            console.log(failed);
        }
    }

};


export default base.init;
